// extracted by mini-css-extract-plugin
export default {"height":"InfiniteScrollWaypoint_height__L1IEz"};